import b from 'b_';

import React, { useEffect, useState } from 'react';

import ProgressCircle from '../../progress-circle/progress-circle';

interface Props {
    onTimerEnd?: () => void;
}

export const QuizTimerCircle = (props: Props) => {
    const { onTimerEnd } = props;
    const [timeLeft, setTimeLeft] = useState<number>(30);

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        const nextTime = (left: number) => {
            timeout = setTimeout(() => {
                left = left - 1;
                setTimeLeft(left);

                if (left) {
                    nextTime(left);
                } else {
                    onTimerEnd?.();
                }
            }, 1000);
        };

        nextTime(timeLeft);

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, []);

    let color = 'green';

    if (timeLeft < 5) {
        color = 'red';
    } else if (timeLeft < 15) {
        color = 'orange';
    }

    return (
        <div className={b('quiz-teacher__timer-circle', { color })}>
            <ProgressCircle
                {...{
                    hideMax: true,
                    max: 30,
                    value: timeLeft,
                    strokeWidth: 8,
                    size: 192,
                }}
            />
        </div>
    );
};
